Review = require './review'

module.exports = class ProductReviews
  constructor: ({productReviews}) ->
    return if $('#partial-rendering-loader').is(':visible')

    {@rootUrl, @locale} = productReviews if productReviews
    return unless @rootUrl and @locale

    @fetchProductReviews()

  fetchProductReviews: ->
    @deals = $('figure.deal-card[data-uuid], figure.deal-card-mini[data-uuid], .carousel-slide-deal[data-uuid]')

    if @deals.length
      csrf = $('meta[name=csrf-token]').attr('content')
      $.ajax
        url: "#{@rootUrl}/product_review_proxy/products.json?locale=#{@locale}&_csrf=#{csrf}"
        type: 'POST'
        contentType: 'application/json'
        data: JSON.stringify @prepareData()
        error: @fetchError
        success: @fetchSuccess

  prepareData: ->
    deal_uuid: @extractDealUuids().join()

  extractDealUuids: ->
    dealUuids = []
    @deals.each ->
      uuid = $(this).data('uuid')
      dealUuids.push(uuid) if uuid.length
    dealUuids

  fetchError: ->

  fetchSuccess: (data) =>
    return unless products = data.products

    @deals.each ->
      $el = $(this)
      uuid = $el.data('uuid')
      params =
        $el: $el
        data: products[uuid]
        uuid: uuid
      (new Review params).render() if params.data
